<template><div><h1 id="rucksendecodes" tabindex="-1"><a class="header-anchor" href="#rucksendecodes"><span>Rücksendecodes</span></a></h1>
<p>Rücksendecodes — Erfassen von Rücksendecodes</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Zum Erfassen einer Retoure (aus dem Warenverkauf) kann ein Retourcode angegeben werden, der die Art der Retoure näher bestimmt. Die Tabelle umfasst die möglichen, für den Benutzer wählbaren Codes.</p>
<p>Pfad: <code v-pre>Verkauf → Tabellen → Rücksendecodes</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>RetCc</dt>
<dd>Rücksendecode, 1-stellig, numerisch</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung des Rücksendecodes</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/auftragsverwaltung.html#Auftragsverwaltung" title="1. Auftragsverwaltung">Auftragsverwaltung</RouteLink></p>
</div></template>


